import {gemStore} from 'app/gemStore';

export const setMediaBreakpointAction = (mediaBreakpoint: number) => gemStore.getState().setMediaBreakpoint(mediaBreakpoint);
export const setMediaInnerHeightAction = (mediaInnerHeight: number) => gemStore.getState().setMediaInnerHeight(mediaInnerHeight);
